<template>
  <!-- 专供小程序的支付通道 : 支付/充值都从这里走, 走到连连支付后再被连连支付回调到相应的页面 -->
  <!-- 
        连连支付 的支付回调地址 : src\view\pay_success\index.vue
        连连支付 的充值回调地址 : src\view\recharge_success\index.vue
     -->
  <div class></div>
</template>

<script>
import { Tag, Col, Toast } from "vant"
import request from "@/utils/request"

export default {
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Toast.name]: Toast
  },

  data() {
    return {}
  },

  created() {
    console.log(this.$route)
    let redirect = this.$route.query.redirect

    if (redirect) {
      location.href = unescape(redirect)
    }
  },

  methods: {}
}
</script>

<style lang="less" scoped>
</style>
